(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .service('PagarmeUtilsService', PagarmeUtilsService);

    PagarmeUtilsService.$inject = ['moment'];

    function PagarmeUtilsService(moment) {
        var ISO_DATE_FORMAT = 'YYYY-MM-DD';
        var DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';

        var service = {
            toAddressComponentModel: toAddressComponentModel,
            toAddressDTO: toAddressDTO,
            toDisplayDate: toDisplayDate,
            toIsoDate: toIsoDate,
            toMonetaryDisplay: toMonetaryDisplay,
            toCentsModel: toCentsModel
        };

        return service;

        function toAddressComponentModel(addressDTO) {
            var addr = addressDTO || {};
            return {
                zipcode: addr.zipcode,
                address: addr.street,
                addressNumber: addr.streetNumber,
                district: addr.neighborhood,
                complement: addr.complementary,
                city: addr.city,
                state: addr.state,
                referencePoint: addr.referencePoint
            };
        }

        function toAddressDTO(componentModel, existingAddressDTO) {
            var addr = existingAddressDTO || {};
            var model = componentModel || {};
            addr.zipcode = model.zipcode;
            addr.street = model.address;
            addr.streetNumber = model.addressNumber;
            addr.neighborhood = model.district;
            addr.complementary = model.complement;
            addr.city = model.city;
            addr.state = model.state;
            addr.referencePoint = model.referencePoint;
            return addr;
        }

        function toDisplayDate(isoDate) {
            if (!isoDate) {
                return isoDate;
            }
            var parsed = moment(isoDate, ISO_DATE_FORMAT, true);
            return parsed.isValid() ? parsed.format(DISPLAY_DATE_FORMAT) : isoDate;
        }

        function toIsoDate(displayDate) {
            if (!displayDate) {
                return displayDate;
            }
            var parsed = moment(displayDate, DISPLAY_DATE_FORMAT, true);
            return parsed.isValid() ? parsed.format(ISO_DATE_FORMAT) : displayDate;
        }

        function toMonetaryDisplay(cents) {
            if (cents === null || cents === undefined || cents === '') {
                return null;
            }
            var num = Number(cents);
            return isNaN(num) ? null : num / 100;
        }

        function toCentsModel(reais) {
            if (reais === null || reais === undefined || reais === '') {
                return null;
            }
            var num = Number(reais);
            return isNaN(num) ? null : Math.round(num * 100);
        }
    }
})();
